import { RefObject, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = ({ scrollRef }: { scrollRef?: RefObject<HTMLElement> }) => {
  const { pathname } = useLocation()

  useEffect(() => {
    scrollRef?.current?.scrollTo?.({ top: 0 })
    window.scrollTo({ top: 0 })
  }, [scrollRef, pathname])

  return null
}

export default ScrollToTop
